"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactDnd = require("react-dnd");

var _reactDndHtml5Backend = require("react-dnd-html5-backend");

var _immutable = _interopRequireDefault(require("immutable"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var colors = _interopRequireWildcard(require("HubStyleTokens/colors"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var fileTarget = {
  drop: function drop(props, monitor) {
    var onDropFiles = props.onDropFiles,
        folder = props.folder;
    onDropFiles(monitor.getItem().files, folder);
  }
};

var Folder =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Folder, _Component);

  function Folder(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Folder);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Folder).call(this, props));
    _this.handleSelect = _this.handleSelect.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Folder, [{
    key: "handleSelect",
    value: function handleSelect() {
      var _this$props = this.props,
          onSelect = _this$props.onSelect,
          folder = _this$props.folder;
      onSelect(folder);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          folder = _this$props2.folder,
          last = _this$props2.last,
          connectDropTarget = _this$props2.connectDropTarget,
          isOver = _this$props2.isOver;
      return connectDropTarget(_react.default.createElement("div", {
        className: (0, _classNames.default)('folder', {
          'is-last': last,
          'is-over': isOver
        })
      }, _react.default.createElement(_UILink.default, {
        use: "unstyled",
        onClick: this.handleSelect
      }, _react.default.createElement(_UIIcon.default, {
        className: "m-right-4",
        name: "folder",
        color: colors.CALYPSO
      }), folder.get('name'))));
    }
  }]);
  return Folder;
}(_react.Component);

Folder.propTypes = {
  folder: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired,
  last: _react.PropTypes.bool.isRequired,
  isOver: _react.PropTypes.bool.isRequired,
  onSelect: _react.PropTypes.func.isRequired,
  connectDropTarget: _react.PropTypes.func.isRequired
};

var _default = (0, _reactDnd.DropTarget)(_reactDndHtml5Backend.NativeTypes.FILE, fileTarget, function (dragAndDropConnect, monitor) {
  return {
    connectDropTarget: dragAndDropConnect.dropTarget(),
    isOver: monitor.isOver()
  };
})(Folder);

exports.default = _default;
module.exports = exports.default;